import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 text-white text-center space-y-1 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            Legal Agreements
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Terms of Service</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs max-w-xl mx-auto">
            Last Updated: August 26, 2026
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-100 shadow-2xs space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600 leading-normal">
          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">1. Acceptance of Terms</h2>
            <p className="text-[11px] sm:text-xs">By accessing or using E-Learning Hub website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our platform.</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">2. Course Access & Licenses</h2>
            <p className="text-[11px] sm:text-xs">Upon completing payment for a course, E-Learning Hub grants you a non-exclusive, non-transferable lifetime license to access the course content, video lectures, and study materials for your personal education.</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">3. Intellectual Property Rights</h2>
            <p className="text-[11px] sm:text-xs">All video lectures, PDF study materials, quizzes, and certificates are the copyrighted property of E-Learning Hub and its instructors. You may not record, reproduce, distribute, or resell course materials.</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">4. User Account & Conduct</h2>
            <p className="text-[11px] sm:text-xs">You are responsible for maintaining the security of your account credentials. Sharing account access with multiple individuals is strictly prohibited.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
